import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "countdown"]
  static values = {
    interval: { type: Number, default: 30 },
    enabled: { type: Boolean, default: false }
  }

  connect() {
    this.remainingSeconds = this.intervalValue
    if (this.enabledValue) {
      this.start()
    }
  }

  disconnect() {
    this.stop()
  }

  toggle() {
    if (this.enabledValue) {
      this.stop()
    } else {
      this.start()
    }
  }

  start() {
    this.enabledValue = true
    this.remainingSeconds = this.intervalValue
    this.updateCountdown()
    this.timer = setInterval(() => this.tick(), 1000)
    this.updateButtonState()
  }

  stop() {
    this.enabledValue = false
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.updateButtonState()
  }

  tick() {
    this.remainingSeconds--
    this.updateCountdown()

    if (this.remainingSeconds <= 0) {
      this.refresh()
      this.remainingSeconds = this.intervalValue
    }
  }

  refresh() {
    // Dispatch event for dashboard controller to handle
    this.dispatch("refresh")
    // Also trigger Turbo refresh directly
    Turbo.visit(window.location.href, { action: "replace" })
  }

  manualRefresh() {
    this.remainingSeconds = this.intervalValue
    this.updateCountdown()
    this.refresh()
  }

  updateCountdown() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = this.remainingSeconds
    }
  }

  updateButtonState() {
    if (this.hasButtonTarget) {
      this.buttonTarget.dataset.enabled = this.enabledValue
      this.buttonTarget.classList.toggle("bg-emerald-100", this.enabledValue)
      this.buttonTarget.classList.toggle("text-emerald-700", this.enabledValue)
    }
  }
}
